import { useQuery } from "@tanstack/react-query";
import { AxiosInstance } from "./auth/AxiosInstance";

export const getActiveHellocians = async () => {
    const response = await AxiosInstance.get('/hellocians/active');
    return response.data;
};

export const useGetPublicHellocians = () => {
    return useQuery({
        queryKey: ['public-hellocians'],
        queryFn: async () => {
            const response = await AxiosInstance.get('/hellocians/public');
            return response.data;
        }
    });
};
